/** @format */
import React, { FC, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { _$, FormItem, Icon } from 'kpc-react'
import { Select, Option, ConfigProvider } from '@king-design/react'
import { getMetricTags } from 'src/api/ApiDashboard'
import { useAsyncFn } from 'react-use'
import variable from 'src/static/styles/var'

export const initShieldMetrics = [
  {
    Metric: undefined,
    MetricDesc: '',
    MetricTags: undefined
  }
]
interface MetricsParams {
  Metric: string
  MetricDesc: string
  MetricTags: string[]
}

interface SelectMetricTagsProps {
  className?: string
  index: number
  metric: MetricsParams
  productType: number
  instances: any[]
  selectedMetrics: any[]
  metricList: any[]
  changeMetric: (values: MetricsParams) => void
  addMetric: () => void
  removeMetric: (index: number) => void
}

const SelectMetricTags: FC<SelectMetricTagsProps> = ({
  className,
  index,
  productType,
  instances,
  metric,
  selectedMetrics,
  metricList,
  changeMetric,
  addMetric,
  removeMetric
}) => {
  const { Metric, MetricDesc, MetricTags } = metric
  // 获取指标tags
  const [{ value: tags }, getTags] = useAsyncFn(async () => {
    if (productType !== undefined && instances?.length && Metric) {
      const result = await getMetricTags(productType, Metric, instances)
      if (result?.length) {
        changeMetric({
          ...metric,
          MetricTags: MetricTags?.filter(tag => !!result.find(item => item === tag)) || undefined
        })
      } else {
        changeMetric({
          ...metric,
          MetricTags: undefined
        })
      }
      return result || []
    } else {
      changeMetric({
        ...metric,
        MetricTags: undefined
      })
      return []
    }
  }, [productType, instances, Metric, MetricTags])

  // 修改资源重新获取tags
  useEffect(() => {
    getTags()
  }, [productType, instances, Metric])

  return (
    <ConfigProvider value={{ classNamePrefix: 'kd' }}>
      <div className={className}>
        <FormItem
          label="指标"
          hideLabel
          className="marginLeft"
          value={Metric}
          rules={{
            required: true
          }}
          messages={{
            required: _$('请选择指标')
          }}
        >
          <Select
            width={200}
            value={Metric && MetricDesc ? `${Metric}===${MetricDesc}` : undefined}
            filterable
            placeholder={_$('请选择指标')}
            onChangeValue={value => {
              const split = value.split('===')
              changeMetric({
                Metric: split[0],
                MetricDesc: split[1],
                MetricTags: undefined
              })
            }}
          >
            {metricList?.length
              ? metricList.map(item => {
                  const disabled = selectedMetrics.find((c, i) => {
                    return (
                      index !== i &&
                      `${c.Metric}===${c.MetricDesc}` === `${item.metricKey}===${item.metricName}`
                    )
                  })
                  return (
                    <Option
                      key={`${item.metricKey}===${item.metricName}`}
                      value={`${item.metricKey}===${item.metricName}`}
                      disabled={disabled}
                    >
                      {item.metricName}
                    </Option>
                  )
                })
              : null}
          </Select>
        </FormItem>
        {tags?.length ? (
          <FormItem
            hideLabel
            // label="维度"
            value={MetricTags}
          >
            <Select
              width={400}
              value={MetricTags}
              filterable
              multiple
              nowrap
              size="default"
              placeholder={_$('请选择维度，默认为全部维度')}
              onChangeValue={value => {
                changeMetric({
                  ...metric,
                  MetricTags: value
                })
              }}
            >
              {tags?.map(item => (
                <Option key={`${item}`} value={`${item}`}>
                  {item}
                </Option>
              ))}
            </Select>
          </FormItem>
        ) : null}
        {index === selectedMetrics?.length - 1 ? (
          <Icon
            className="ion-plus-circled"
            size={18}
            onClick={() => {
              addMetric()
            }}
          />
        ) : null}
        {selectedMetrics?.length > 1 ? (
          <Icon
            className="ion-trash-a"
            size={20}
            onClick={() => {
              removeMetric(index)
            }}
          />
        ) : null}
      </div>
    </ConfigProvider>
  )
}

export default styled(SelectMetricTags)`
  display: flex;
  margin-bottom: 20px;
  .k-form-item:not(:last-of-type) {
    margin-bottom: 0;
  }
  .marginLeft {
    margin-left: 100px;
  }
  & .k-select {
    margin-right: 4px;
    .k-tag {
      height: 26px;
    }
  }
  .k-select .k-input {
    line-height: 1.5;
  }
  .k-icon {
    margin-left: 16px;
    cursor: pointer;
    line-height: 32px;
    transition: all ease-in-out 0.3s;
    &:hover {
      color: ${variable.primaryColor};
    }
  }
`
